import React, { useEffect } from 'react';
import { Switch, FormField, ArticleParagraph1, Tooltip, IconFunctionalInformation12, UIText2 } from '@cian/ui-kit';

import styles from './styles.css';
import { useBaseField } from '../BaseField';
import { IField } from '../../types/calculator';

export const SwitchField: React.FC<IField> = props => {
  const { label, defaultValue, disabled, tooltip } = props;
  const {
    field: { onChange, name, value, ref },
    fieldState,
  } = useBaseField(props);

  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
  }, []);

  const isError = fieldState.isDirty || fieldState.invalid;

  return (
    <FormField
      errorMessage={fieldState.isDirty ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <div className={styles.root}>
        {tooltip ? (
          <Tooltip title={tooltip} placement="bottom">
            <div className={styles.label}>
              <UIText2>{label}</UIText2>
              <div className={styles.icon}>
                <IconFunctionalInformation12 color="icon-main-default" />
              </div>
            </div>
          </Tooltip>
        ) : (
          <ArticleParagraph1>{label}</ArticleParagraph1>
        )}
        <Switch
          data-testid={name}
          checked={Boolean(value)}
          onChange={(_, value) => onChange(value)}
          disabled={disabled}
          invalid={Boolean(isError && fieldState.error)}
          name={name}
          ref={ref}
        />
      </div>
    </FormField>
  );
};

SwitchField.displayName = 'SwitchField';
